module.exports = __webpack_public_path__ + "img/w3_question_black.b072faca.png";